export function Things10({ width = 256, height = 160 }: { width: number; height: number }) {
    const w = `${width}`;
    const h = `${height}`;
    return (
        <div>
            <svg width={w} height={h} viewBox="0 0 256 160" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.5134 64.3487L7.54141 86.334L44.3313 141.473L105.563 123.071L114.072 104.112L77.801 52.6826L15.5134 64.3487Z"
                    fill="#7CDFFF"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24.743 77.8757L53.601 120.44L114.072 104.113L87.0636 65.8369L24.743 77.8757Z"
                    fill="#06BEFB"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M75.4141 48.9873L12.6275 60.2217L24.8468 78.1319L87.4529 66.007L75.4141 48.9873Z"
                    fill="#FF937B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.48 82.24L15.7144 98.9412L24.873 78.1059L12.6278 60.2217L4.48 82.24Z"
                    fill="#FF5844"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M87.2455 66.0168C87.2455 66.0168 93.3695 75.223 101.171 83.134L101.745 83.7104C101.841 83.806 101.937 83.9014 102.034 83.9965C109.142 91.0014 117.394 97.3328 117.394 97.3328L55.3327 114.145C55.3327 114.145 48.5354 108.384 40.6991 99.0961L40.1736 98.4701C39.9986 98.2605 39.8237 98.0501 39.649 97.839L39.1257 97.2036C39.0386 97.0974 38.9516 96.9911 38.8647 96.8846L38.3444 96.2445L37.8266 95.6024C30.9421 87.0299 24.873 78.1322 24.873 78.1322L87.2455 66.0168ZM221.458 88.5488C221.458 88.5488 228.365 89.3414 236.988 93.1593C245.169 96.7845 249.57 101.023 249.845 101.292L249.859 101.306L242.336 109.728C242.336 109.728 239.251 107.405 231.439 105.248C223.886 103.162 217.612 103.043 217.023 103.037L216.978 103.036L221.458 88.5488ZM213.76 47.1836L222.596 73.1472C222.596 73.1472 222.59 73.1471 222.577 73.1469L222.479 73.146C222.464 73.1459 222.446 73.1458 222.428 73.1458L222.222 73.1458C220.474 73.152 212.826 73.3195 203.72 75.6265C193.494 78.2177 189.414 81.1546 189.414 81.1546L176.454 62.9991L176.467 62.9869C176.775 62.697 182.621 57.2712 193.426 52.7542C199.639 50.1574 205.157 48.7331 208.871 47.9765L209.355 47.8795C211.171 47.5226 212.502 47.3343 213.202 47.2471L213.37 47.2266C213.626 47.1961 213.76 47.1836 213.76 47.1836ZM156.055 18.46L170.633 47.0526C170.633 47.0526 158.988 56.0437 140.27 62.9718C123.201 69.2889 110.594 69.5937 108.913 69.6054L108.722 69.6055L107.708 45.7292C107.708 45.7292 115.818 44.6972 130.852 36.4433C146.126 28.0585 156.055 18.46 156.055 18.46Z"
                    fill="#B6F0FF"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M52.7176 78.7861L69.3351 100.61L63.9119 102.083L47.1033 79.8524L52.7176 78.7861ZM77.4344 73.4229L79.9301 76.9778L69.7171 79.7023L72.1409 82.6522C72.1409 82.6522 85.8758 78.1407 88.7089 87.7203C91.872 98.4278 77.0063 98.827 75.5118 98.8401L75.3915 98.8405L74.6355 94.6037C74.6355 94.6037 74.7007 94.6057 74.8205 94.6069L75.1299 94.607C77.3858 94.5903 86.4931 94.1613 84.1691 88.2499C81.914 82.5142 70.3245 87.5682 70.3245 87.5682L61.9043 77.3564L77.4344 73.4229Z"
                    fill="#06BEFB"
                />
            </svg>
        </div>
    );
}

export function Things39({ width = 256, height = 224 }: { width: number; height: number }) {
    const w = `${width}`;
    const h = `${height}`;
    return (
        <div>
            <svg width={w} height={h} viewBox="0 0 256 224" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M233.368 19.5684C237.569 19.5684 240.975 22.9744 240.975 27.1758V177.828C240.975 182.032 237.569 185.436 233.368 185.436L160.519 185.435V197.609L190.957 197.61V204.078H64.5255V197.61L94.9592 197.609V185.435L22.1102 185.436C17.9088 185.436 14.5002 182.032 14.5002 177.828V27.1758C14.5002 22.9744 17.9088 19.5684 22.1102 19.5684H233.368Z"
                    fill="#767676"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M233.692 163.671C233.692 165.853 231.924 167.616 229.745 167.616H25.7335C23.5542 167.616 21.7864 165.853 21.7864 163.671V30.2532C21.7864 28.0764 23.5542 26.3086 25.7335 26.3086H229.745C231.924 26.3086 233.692 28.0764 233.692 30.2532V163.671Z"
                    fill="#B6F0FF"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M42.5715 26.3086H212.705L211.171 167.616H45.8102L42.5715 26.3086Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M156.097 34.6807L51.6746 35.8925L53.223 117.537L156.356 119.16L156.097 34.6807Z"
                    fill="#7CDFFF"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M104.485 46.5977L138.35 81.6851L130.292 82.8695L129.357 108.243L111.506 108.719L110.796 85.7269L97.9445 86.0286L98.2911 109.215L80.9319 108.734L78.8749 83.1412L68.9336 81.8796L104.485 46.5977Z"
                    fill="#06BEFB"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M54.5823 154.391L156.189 154.657L156.461 160.876L54.9438 161.023L54.5823 154.391ZM54.4013 141.435L156.048 141.747L156.268 147.931L54.7578 148.083L54.4013 141.435ZM53.5979 128.321L155.235 128.613L155.494 134.811L53.9894 134.973L53.5979 128.321ZM165.752 124.26L203.632 124.527L203.735 130.75L165.887 130.898L165.752 124.26ZM165.686 111.305L203.574 111.621L203.654 117.805L165.816 117.952L165.686 111.305ZM165.336 98.0791L203.214 98.3459L203.313 104.569L165.471 104.717L165.336 98.0791ZM165.27 85.1238L203.158 85.4405L203.237 91.6241L165.4 91.7713L165.27 85.1238ZM164.981 72.0146L202.853 72.3014L202.95 78.5L165.113 78.6621L164.981 72.0146ZM165.113 34.7637L203.465 35.2125L202.891 65.1959L165.021 65.7893L165.113 34.7637Z"
                    fill="#C3CCD9"
                />
            </svg>
        </div>
    );
}

export function Realestate27({ width = 256, height = 192 }: { width: number; height: number }) {
    const w = `${width}`;
    const h = `${height}`;
    return (
        <div>
            <svg width={w} height={h} viewBox="0 0 256 192" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M134.53 10.0015L115.283 13.5946L119.135 18.7276L137.614 181.186L147.621 181.486L132.735 17.4423L134.53 10.0015Z"
                    fill="#C9AC82"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M46.5 31.0895L58.306 129.644L208.704 114.758L201.518 17.7437L46.5 31.0895Z"
                    fill="#F7D857"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M142.387 176.274L138.099 165.725L136.19 179.183L124 177.001L132.198 183H154.827L160.291 176.547L153.559 178.456L160.105 164.636L150.277 175.186L151.842 154L142.387 176.274Z"
                    fill="#2EE69F"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M75.4429 64.4102L81.3397 64.7305L73.3897 88.9215L69.1478 89.1761L59.4607 66.9767L64.2036 65.3095L71.1394 81.5422L75.4429 64.4102ZM101.206 60.8984C109.004 58.5126 112.203 62.5615 112.203 62.5615L110.597 65.9575C110.597 65.9575 108.737 64.5819 104.947 64.8981C101.05 65.2266 98.7461 68.5733 102.479 71.0905C103.474 71.7646 104.882 72.0345 106.361 72.3476L106.718 72.4238C110.053 73.1469 113.613 74.2663 113.583 80.8105C113.566 86.1981 108.667 88.5593 104.056 88.3416C100.064 88.1569 96.3027 85.7053 96.3027 85.7053L98.1055 81.4962C98.1055 81.4962 100.598 83.8739 104.643 83.7876C108.836 83.6973 109.94 78.3548 106.006 77.6896C102.676 77.1311 98.1383 75.6774 96.5409 73C94.4631 69.5014 94.1222 63.0707 101.206 60.8984ZM90.0466 63.0029L91.4222 87.9823L86.9668 87.6415L85.4269 63.1713L90.0466 63.0029ZM129.409 58.2456L135.15 58.3113L137.121 84.1449L132.616 84.5227L122.095 72.6551L124.251 85.8573L118.699 86.1776L115.591 59.9909L119.96 59.7034L130.739 72.1254L129.409 58.2456ZM146.849 57.0958L148.734 83.8739L144.455 84.3009L141.461 57.6091L146.849 57.0958ZM171.417 53.6189L173.844 79.8097L169.237 80.6639L159.139 68.5992L161.237 81.7685L155.591 82.6226L152.597 57.0437L156.642 56.3702L167.594 70.057L166.112 54.2226L171.417 53.6189ZM185.546 53.2555C191.491 52.48 195.663 56.766 196.349 57.5239L196.413 57.5952C196.436 57.6226 196.449 57.6371 196.449 57.6371L193.927 60.721C193.927 60.721 192.03 58.1011 188.568 58.0518C184.121 57.9779 181.982 61.0167 181.661 65.5871C181.284 71.139 184.762 74.5432 188.618 74.765C193.311 75.036 192.704 70.5846 192.704 70.5846L187.386 70.1042L187.542 65.8581L196.264 66.9628C196.264 66.9628 197.036 70.5436 195.016 76.2022C193.385 80.7973 184.043 80.5879 179.349 74.8307C173.806 68.051 177.058 54.356 185.546 53.2555Z"
                    fill="#917655"
                />
            </svg>
        </div>
    );
}

export function Business07({ width = 176, height = 169 }: { width: number; height: number }) {
    const w = `${width}`;
    const h = `${height}`;
    return (
        <div>
            <svg width={w} height={h} viewBox="0 0 176 169" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0.882568 0L168.963 0.726849L174.811 162.132L2.34548 168.677L0.882568 0Z"
                        fill="#E8EEF4"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M118.13 22.2656L118.139 38.4957C110.166 39.5591 104.016 46.3524 104.016 54.5733C104.016 60.8971 107.655 66.3761 112.962 69.052L113.147 69.1436L107.635 85.1576L108.475 85.4299C110.092 85.9307 111.763 86.3093 113.477 86.5545C97.7464 84.3095 85.6548 70.8462 85.6548 54.5733C85.6548 36.7301 100.195 22.2656 118.13 22.2656Z"
                        fill="#06C484"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M134.23 63.0464L146.835 69.6934L146.757 69.8384C141.282 79.985 130.512 86.884 118.129 86.884C114.764 86.884 111.523 86.3741 108.475 85.4298L107.635 85.1575L113.147 69.1435C115.313 70.2013 117.748 70.7952 120.323 70.7952C126.207 70.7952 131.363 67.6946 134.23 63.0464Z"
                        fill="#FF5844"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M118.538 22.2674C136.284 22.4866 150.604 36.8648 150.604 54.5733C150.604 59.8874 149.312 64.9029 147.03 69.3242L146.674 69.9994L134.125 63.2148C135.711 60.7129 136.629 57.7496 136.629 54.5733C136.629 45.6146 129.328 38.3513 120.324 38.3513C119.583 38.3513 118.853 38.4004 118.139 38.4957L118.13 22.2656L118.538 22.2674Z"
                        fill="#0293F4"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M26.6773 99.0376L27.3124 143.524L153.389 139.596L153.528 142.184L23.7642 147.91L23.7744 147.833L23.7324 147.842L23.7984 99.5832L26.6773 99.0376Z"
                        fill="#C3CCD9"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M30.2982 140.502L148.324 135.777L147.954 132.688C147.954 132.688 145.99 132.504 143.664 130.938C138.849 127.699 137.332 116.653 129.617 117.304C119.959 118.124 122.63 132.098 112.492 132.231C102.075 132.369 102.554 109.193 90.085 109.809C78.3817 110.382 79.6051 130.399 70.5587 130.869C62.6819 131.279 61.7205 120.508 53.9078 120.372C45.6215 120.227 42.4041 131.074 38.1525 135.437C34.5429 139.144 30.2982 140.502 30.2982 140.502Z"
                        fill="#06C484"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.9757 24.7189L63.1798 22.9009V27.9906L21.3436 29.08L20.9757 24.7189Z"
                        fill="#C3CCD9"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M21.7078 35.0777L62.9955 34.3508L63.1795 39.8048H22.0809L21.7078 35.0777Z"
                        fill="#C3CCD9"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M21.8916 46.8942L64.0939 45.0762V50.1658L22.256 51.2553L21.8916 46.8942Z"
                        fill="#C3CCD9"
                    />
                </g>
            </svg>
        </div>
    );
}
